module.exports = __webpack_public_path__ + "static/media/AdaBotSleep.872f17d3.png";